<template>
  <span>
    <small class="me-2">
      <strong v-if="partner.type === 'instance'">{{partner.name}}</strong>
      <span v-else>{{partner.name}}</span>
    </small>
    <b-icon
        v-if="partner.type === 'company'"
        icon="people-fill"
        variant="secondary"
        v-b-tooltip.hover.right
        title="Persona"
    />
    <b-icon
        v-else-if="partner.type === 'Subject' || partner.type === 'partner'"
        icon="person-fill"
        variant="secondary"
        b-v-tooltip.hover.right
        title="Persona"
    />
    <b-icon
        v-else-if="partner.type === 'managedCompany'"
        icon="shield-fill"
        variant="secondary"
        v-b-tooltip.hover.right
        title="Empresa administrada"
    />
    <b-icon
        v-else
        icon="briefcase-fill"
        variant="secondary"
        v-b-tooltip.hover.right
        title="Empresa asociada a la instancia"
    />
  </span>
</template>

<script>
export default {
  name: "Inline-partner.vue",

  props: {
    partner: {
      type: Object,
      required: true
    },
  },
  
  data() {
    return {
      percentage: this.partner.percentage ?? null
    }
  }
}
</script>

<style scoped>
svg {
  padding-bottom: 0.1rem;
  font-size: 0.9rem;
  fill-opacity: 0.7;
}

</style>